export default Object.freeze([
  {
    "displayName": "Audience",
    "name": "audience"
  },
  {
    "displayName": "Company Name",
    "name": "companyName"
  },
  {
    "displayName": "Industry",
    "name": "industry"
  },
  {
    "displayName": "Sub Industry",
    "name": "subIndustry"
  },
  {
    "displayName": "Employee Count",
    "name": "employeeCount"
  },
  {
    "displayName": "Employee Range",
    "name": "employeeRange"
  },
  {
    "displayName": "Marketing Alias",
    "name": "marketingAlias"
  },
  {
    "displayName": "Annual Sales",
    "name": "annualSales"
  },
  {
    "displayName": "Revenue Range",
    "name": "revenueRange"
  },
  {
    "displayName": "City",
    "name": "city"
  },
  {
    "displayName": "State",
    "name": "state"
  },
  {
    "displayName": "Country Code",
    "name": "countryCode"
  },
  {
    "displayName": "Country Name",
    "name": "countryName"
  }
])



// WEBPACK FOOTER //
// ./src/scripts/constants/DemandbaseProperties.js